import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get, throttle } from "lodash";
import { AccessType } from "@quintype/components";
import StickyBanner from "../../molecules/sticky-banner";
import StickyNavbar from "../../molecules/sticky-navbar";
import {
  setMakeSecondaryApiCallsTriggered,
  setUserDetails,
  setIsLogin,
  OPEN_HAMBURGER_MENU,
  OPEN_SEARCHBAR
} from "../../store/actions";
import {
  addTokensToLocalStorage,
  getUserDetails,
  getAuthCookie,
  initializeAuthSync,
  clearAuthCookies,
  refreshAccessToken
} from "../../helper/utils";
import GoogleOneTapSignInUp from "../../atoms/google-one-tap";
import { GoogleOAuthProvider, googleLogout } from "@react-oauth/google";
import { GlobalSubscriptionSyncer } from "../../helper/GlobalSubscriptionSyncer";
import DesktopHeader from "./new-pv-header/desktop-header";
import MobileHeader from "./new-pv-header/mobile-header";
import EPaperBanner from "../../atoms/epaper-banner";
// import ElectionFloatingWidget from "../../atoms/election-floating-widget";
import {
  pushPageDataLayer,
  addLogoutToDataLayer,
  addAuthTrackingToDataLayer
} from "../../helper/datalayer-utils";
import { Snackbar } from "../../common/snackbar";
import { createScrollHandler } from "./useScrollBehavior";
import { OnboardModal } from "../../pages/subscribe-page/onboard-modal";
import { useSubscriptionRetry } from "../../atoms/my-account/my-subscription/useSubscriptionRetry";
import { requestAccessTypeToken } from "../../pages/subscription-page/auth-client";
const REDIRECT_URL_QUERY_PARAM = "redirect_url";
const SHOW_SUPPORT_STRIP_ON_REDIRECT_KEY = "show_support_strip_on_redirect";

const NavigationSchema = () => {
  // Get navigation menu data from redux
  const navigationMenu = useSelector((state) => get(state, ["qt", "data", "navigationMenu"], {}));
  const schema = useMemo(() => {
    const primaryMenus = navigationMenu?.primaryMenus || [];
    const secondaryMenus = navigationMenu?.secondaryMenus || [];
    // Merge both arrays
    const allMenus = [...primaryMenus, ...secondaryMenus];
    // Helper function to build schema recursively
    const buildMenuSchema = (item) => {
      if (!item?.title || !item?.url) return null;
      const menuSchema = {
        "@type": "SiteNavigationElement",
        name: item.title,
        url: item.url
      };
      return menuSchema;
    };
    // Build navigation schema
    const hasPart = allMenus.map(buildMenuSchema).filter(Boolean);
    return {
      "@context": "https://schema.org",
      "@type": "SiteNavigationElement",
      name: "Prajavani Main Navigation",
      hasPart
    };
  }, [navigationMenu]);
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema)
      }}
    />
  );
};
const HeaderInner = ({ getSubscriptionForUser, initAccessType }) => {
  const dispatch = useDispatch();

  // Early redirect for SSO auth tokens - before rendering to avoid showing anonymous page
  if (typeof window !== "undefined") {
    const rawSearch = (window.location.search || "").replace(/\?/g, "&").replace("&", "?");
    const searchParams = new URLSearchParams(rawSearch);
    const access_token = searchParams.get("access_token");
    const refresh_token = searchParams.get("refresh_token");

    if (access_token && refresh_token && !sessionStorage.getItem("auth_redirect_in_progress")) {
      // Mark that we're handling this redirect to prevent loops
      sessionStorage.setItem("auth_redirect_in_progress", "true");

      // Set cookie immediately before redirect so next page request includes auth
      const accessToken = access_token.replaceAll(" ", "+");
      document.cookie = [`qt-auth=${encodeURIComponent(accessToken)}`, "Path=/", "Secure", "SameSite=Lax"].join("; ");

      // Store tokens in localStorage for later use
      const refreshToken = refresh_token.replaceAll(" ", "+");
      localStorage.setItem("access_token", accessToken);
      localStorage.setItem("refresh_token", refreshToken);

      searchParams.delete("access_token");
      searchParams.delete("refresh_token");

      // Redirect to clean URL without tokens but preserve valid query params
      // This happens BEFORE component renders, so no flash
      const newSearch = searchParams.toString();
      const cleanUrl = window.location.pathname + (newSearch ? `?${newSearch}` : "") + (window.location.hash ? window.location.hash : "");
      window.location.replace(cleanUrl);
      return null; // Prevent render
    }
  }

  if (typeof window !== "undefined") {
    sessionStorage.removeItem("auth_redirect_in_progress");
  }
  const userdetails = useSelector((state) => get(state, ["user", "user"], {}));
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));
  const isSubscriber = useSelector((state) => get(state, ["qt", "config", "subscriber"], "") === "true");
  const pageType = useSelector((state) => get(state, ["qt", "pageType"]));
  const pageData = useSelector((state) => get(state, ["qt", "data"], []));
  const isHamburgerMenuOpen = useSelector((state) => get(state, ["isHamburgerMenuOpen"], false));
  const bottomNavBarMenus = useSelector((state) => get(state, ["qt", "data", "navigationMenu", "bottomNavBar"], []));
  const makeSecondaryApiCallsDelay = 2750;
  const [makeSecondaryApiCalls, setMakeSecondaryApiCalls] = useState(false);
  const [isMobile, setMobile] = useState(true);
  const [loadOneTap, setGoogleOneTap] = useState(false);
  console.log(loadOneTap, "loadOneTap");
  const [redirectURL, setRedirectUrl] = useState("");
  const [showStickyNavbar, setShowStickyNavbar] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollDirection, setScrollDirection] = useState("up");
  const [showPrimaryHeader, setShowPrimaryHeader] = useState(true);
  const [showSecondaryHeader, setShowSecondaryHeader] = useState(true);
  const [showAdBanner, setShowAdBanner] = useState(false);
  const [adClosed, setAdClosed] = useState(false);
  const [showDesktopSecondaryHeader, setShowDesktopSecondaryHeader] = useState(true);
  const [showOnboardModal, setShowOnboardModal] = useState(false);
  const [showRedirectSupportStrip, setShowRedirectSupportStrip] = useState(false);
  const [showPaymentProcessingBanner, setShowPaymentProcessingBanner] = useState(false);
  const [subscriptionActive, setSubscriptionActive] = useState(isSubscriber);
  const paymentProcessingActiveRef = useRef(false);
  const { start: startSubscriptionRetry } = useSubscriptionRetry();
  const isOnboardCompleted =
    get(userdetails, ["metadata", "tpml_onboarding_completed"], "") === true;
  const openAccountModal = () => {
    const currentUrl = window.location.origin + window.location.pathname + window.location.search;
    window.location.href = `/profile?returnUrl=${encodeURIComponent(currentUrl)}`;
  };
  useEffect(() => {
    const isUserDetailsLoaded = Object.keys(userdetails || {}).length > 0;
    if (isUserLogin && isSubscriber && !isOnboardCompleted && isUserDetailsLoaded) {
      setShowOnboardModal(true);
    } else {
      setShowOnboardModal(false);
    }
  }, [isUserLogin, isSubscriber, isOnboardCompleted, userdetails]);
  const GoogleClientId = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "google_client_id"], "")
  );
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  const dataLayerPushedRef = useRef(null);
  const trackingTimerRef = useRef(null);
  const trackingDataRef = useRef({ pageType, userdetails, pageData });
  useEffect(() => {
    trackingDataRef.current = { pageType, userdetails, pageData };
  }, [pageType, userdetails, pageData]);
  useEffect(() => {
    if (typeof window === "undefined" || !pageType) return;
    const contentId = pageData?.story?.id || pageData?.section?.id || pageData?.tag?.id || "";
    const userId = userdetails?.userData?.id || userdetails?.id || "anonymous";
    const currentRouteId = `${pageType}-${contentId}-${userId}`;
    if (dataLayerPushedRef.current !== currentRouteId) {
      dataLayerPushedRef.current = currentRouteId;
      if (trackingTimerRef.current) clearTimeout(trackingTimerRef.current);
      trackingTimerRef.current = setTimeout(() => {
        const { pageType: pt, userdetails: ud, pageData: pd } = trackingDataRef.current;
        pushPageDataLayer(pt, ud, pd);
      }, 150);
    }
  }, [pageType, pageData, userdetails]);

  useEffect(() => {
    document.documentElement.classList.remove("sso-auth-loading");
  }, []);

const PAYMENT_PROCESSING_STATE_KEY = "subscribe_payment_processing_state";

const ensureAT = async () => {
    if (window.AccessType?.setUser) return true;
    return new Promise(r => {
      let a = 0;
      const c = setInterval(() => {
        if (window.AccessType?.setUser || ++a > 100) {
          clearInterval(c);
          r(!!window.AccessType?.setUser);
        }
      }, 100);
      if (!isInit.current) {
        isInit.current = true;
        initAccessType(() => {
          if (window.AccessType?.setUser) {
            clearInterval(c);
            r(true);
          }
        });
      }
    });
  };

  const syncUser = async () => {
      const isReady = await ensureAT();
      if (!isReady) return;

      let token;

      try {
        token = await requestAccessTypeToken("");
      } catch (e) {
      console.error("[header] Failed to get AccessType token:", e);
        return;
      }

      const email = userdetails?.userData?.emails?.[0] || userdetails?.email;
      const phone = userdetails?.userData?.phone || userdetails?.phone || userdetails?.phoneNumbers?.[0] || userdetails?.mobile || userdetails?.userData?.phoneNumbers?.[0];

      try {
        console.log("[header] Setting user in AccessType:", { email, phone, token });
        await window.AccessType.setUser({ emailAddress: email, mobileNumber: phone, accesstypeJwt: token });
      } catch (e) {
      console.error("[header] window.AccessType.setUser failed:", e);
      }
    };

  useEffect(() => {
    if (typeof window === "undefined") return;
    const shouldShowRedirect = sessionStorage.getItem(SHOW_SUPPORT_STRIP_ON_REDIRECT_KEY) === "1";

    let isProcessingActive = false;
    try {
      const stateStr = sessionStorage.getItem(PAYMENT_PROCESSING_STATE_KEY);
      if (stateStr) {
        const state = JSON.parse(stateStr);
        if (state && state.active) {
          isProcessingActive = true;
        }
      }
    } catch (e) {
      console.warn("Failed to read payment processing state in header:", e);
    }

    if (shouldShowRedirect || isProcessingActive) {
      setShowRedirectSupportStrip(true);
    } else {
      setShowRedirectSupportStrip(false);
    }

    if (shouldShowRedirect) {
      sessionStorage.removeItem(SHOW_SUPPORT_STRIP_ON_REDIRECT_KEY);
    }
  }, [pageType]);

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return;

    const appendRedirectUrlToSubscribeLink = (event) => {
      const anchor = event.target?.closest?.("a[href]");
      if (!anchor) return;

      const rawHref = anchor.getAttribute("href");
      if (!rawHref) return;

      let targetUrl;
      try {
        targetUrl = new URL(rawHref, window.location.origin);
      } catch (e) {
        return;
      }

      if (targetUrl.origin !== window.location.origin) return;
      if (!targetUrl.pathname.startsWith("/subscribe")) return;
      if (targetUrl.searchParams.get(REDIRECT_URL_QUERY_PARAM)) return;

      const currentPage = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      targetUrl.searchParams.set(REDIRECT_URL_QUERY_PARAM, currentPage);

      anchor.setAttribute("href", `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`);
    };

    document.addEventListener("click", appendRedirectUrlToSubscribeLink, true);
    return () => {
      document.removeEventListener("click", appendRedirectUrlToSubscribeLink, true);
    };
  }, []);

  // Callback to fetch subscriptions for verification - using getSubscriptionForUser from AccessType props
  const fetchSubscription = useCallback(async () => {
    if (typeof getSubscriptionForUser !== "function") return [];
    console.log("[Header] fetchSubscription called");
    try {
      await syncUser();
      const subs = await getSubscriptionForUser();
      console.log("[Header] getSubscriptionForUser result:", subs);
      const subscriptionList = Array.isArray(subs)
        ? subs
        : subs?.subscriptions || [];
      return subscriptionList;
    } catch (e) {
      console.error("[Header] Failed to fetch subscriptions:", e);
      return [];
    }
  }, [getSubscriptionForUser]);

  // Start payment processing verification with retry logic
  const startPaymentProcessingVerification = useCallback(
    (expectedPlanId) => {
      if (paymentProcessingActiveRef.current) {
        // Ensure state is persisted even if already active
        setShowPaymentProcessingBanner(true);
        return;
      }

      // Wait for auth to complete before starting retry logic
      if (!isUserLogin || !userdetails) {
        return;
      }

      paymentProcessingActiveRef.current = true;

      // Show payment processing banner
      setShowPaymentProcessingBanner(true);

      // Show support strip on the next redirected page only for this flow
      if (typeof window !== "undefined") {
        sessionStorage.setItem(SHOW_SUPPORT_STRIP_ON_REDIRECT_KEY, "1");
      }

      // Get expected plan ID from parameter, or fallback to sessionStorage
      let planId = expectedPlanId || null;

      // Persist payment processing state
      if (typeof window !== "undefined") {
        sessionStorage.setItem(
          PAYMENT_PROCESSING_STATE_KEY,
          JSON.stringify({
            active: true,
            startedAt: Date.now(),
            expectedPlanId: planId,
          })
        );
      }
      console.log("[Header] Starting subscription retry with expected plan ID:", planId);
      startSubscriptionRetry({
        fetchSubscription,
        expectedPlanId: planId,

        onSuccess: (data) => {
          console.log("[Header] Subscription retry succeeded, clearing payment processing state and sending success email");
          paymentProcessingActiveRef.current = false;

          // Send success email
          try {
            if (data) {
              const selectedPlan = data;

              const email = userdetails?.userData?.emails?.[0] || userdetails?.email || "";
              const phone = userdetails?.userData?.phoneNumbers?.[0] || userdetails?.userData?.phone || userdetails?.phone || "";
              const name = userdetails?.metadata?.first_name || userdetails?.name || "";
              const paymentAmount = (selectedPlan.plan_amount_cents || 0) / 100;
              const currencySymbol = selectedPlan.price_currency === "INR" ? "₹" : selectedPlan.price_currency === "USD" ? "$" : "";

              if (email || phone) {
                fetch("/subscription-success-email", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    email,
                    phone,
                    name,
                    plan_name: selectedPlan.plan_name || "",
                    payment_amount: paymentAmount,
                    currencySymbol,
                    paymentCurrency: selectedPlan.price_currency || "",
                    end_timestamp: selectedPlan?.end_timestamp || "",
                    start_timestamp: selectedPlan?.created_at || "",
                    id: selectedPlan?.subscription_plan_id || ""
                  })
                }).catch((e) => {
                  console.error("[Header] Failed to send subscription success email:", e);
                });
              }
            }
          } catch (e) {
            console.warn("[Header] Failed to send success email:", e);
          }

          // Clear payment processing state
          if (typeof window !== "undefined") {
            sessionStorage.removeItem(PAYMENT_PROCESSING_STATE_KEY);
            sessionStorage.removeItem(SHOW_SUPPORT_STRIP_ON_REDIRECT_KEY);
          }
          !isOnboardCompleted && setShowOnboardModal(true);
          setShowPaymentProcessingBanner(false);
          setShowRedirectSupportStrip(false);
          setSubscriptionActive(true);
        },

        onTimeout: async () => {
          console.warn("[Header] Subscription retry timed out, clearing payment processing state");
          paymentProcessingActiveRef.current = false;

          if (typeof window !== "undefined") {
            sessionStorage.removeItem(PAYMENT_PROCESSING_STATE_KEY);
            sessionStorage.removeItem("subscriptionData");
            sessionStorage.removeItem("isSubscribed");
            sessionStorage.setItem("user_paid_status", "unpaid");
            sessionStorage.removeItem(SHOW_SUPPORT_STRIP_ON_REDIRECT_KEY);
          }

          setShowPaymentProcessingBanner(false);
          setShowRedirectSupportStrip(false);
        },
      });
    },
    [
      fetchSubscription,
      setShowPaymentProcessingBanner,
      startSubscriptionRetry,
      isUserLogin,
      userdetails,
    ]
  );

  // Check for payment processing state and initiate retry logic
  useEffect(() => {
    if (typeof window === "undefined" || !isUserLogin) return;

    try {
      const stateStr = sessionStorage.getItem(PAYMENT_PROCESSING_STATE_KEY);
      if (stateStr) {
        const state = JSON.parse(stateStr);
        if (state && state.active && !paymentProcessingActiveRef.current) {
          console.log("[Header] Found active payment processing state, starting verification");
          startPaymentProcessingVerification(state.expectedPlanId);
        }
      }
    } catch (e) {
      console.warn("[Header] Failed to check payment processing state:", e);
    }
  }, [isUserLogin, startPaymentProcessingVerification]);

  const toggleHandler = () => {
    dispatch({
      type: OPEN_HAMBURGER_MENU,
      isHamburgerMenuOpen: !isHamburgerMenuOpen
    });
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false
    });
  };
  const getScroll = createScrollHandler({
    lastScrollY,
    makeSecondaryApiCalls,
    adClosed,
    setMakeSecondaryApiCalls,
    setShowPrimaryHeader,
    setShowSecondaryHeader,
    setShowAdBanner,
    setShowStickyNavbar,
    setShowDesktopSecondaryHeader,
    setScrollDirection,
    setLastScrollY,
    showPrimaryHeader,
    showSecondaryHeader,
    showAdBanner,
    showStickyNavbar,
    showDesktopSecondaryHeader
  });
  useEffect(() => {
    setRedirectUrl(window.location.href);
    if (window && window.innerWidth < 1025) {
      setMobile(true);
    } else {
      setMobile(false);
      setMakeSecondaryApiCalls(true);
    }
    if (window) {
      initializeAuthSync();

      const rawSearch = (window.location.search || "").replace(/\?/g, "&").replace("&", "?");
      const searchParamsObj = new URLSearchParams(rawSearch);
      const access_token = searchParamsObj.get("access_token");
      const refresh_token = searchParamsObj.get("refresh_token");
      const userLocalStorage = localStorage.getItem("user");
      const stored_access_token = getAuthCookie("st-access-token");
      const stored_refresh_token = getAuthCookie("st-refresh-token");

      console.log("[COOKIE SYNC][HEADER] Initialized sync. Cookies present:", {
        hasAccessToken: !!stored_access_token,
        hasRefreshToken: !!stored_refresh_token
      });

      if (stored_refresh_token) {
        if (stored_access_token) {
          console.log("[COOKIE SYNC][HEADER] Cookies found, user logged in. Dispatching setIsLogin(true)");
          dispatch(setIsLogin(true));
          if (!userLocalStorage || userLocalStorage === "undefined" || userLocalStorage.trim() === "") {
            console.log("[COOKIE SYNC][HEADER] Local user details missing. Fetching from backend...");
            getUserDetails()
              .then((data) => {
                if (data && data.status !== 401) {
                  dispatch(setUserDetails(data || {}));
                  window.localStorage.setItem("user", JSON.stringify(data));
                } else if (data?.status === 401) {
                  console.log("[COOKIE SYNC][HEADER] Cookie-based user details returned 401. Clearing tokens and logging out.");
                  localStorage.removeItem("access_token");
                  localStorage.removeItem("refresh_token");
                  localStorage.removeItem("user");
                  localStorage.removeItem("commentsToken");
                  clearAuthCookies();
                  googleLogout();
                  dispatch(setIsLogin(false));
                  dispatch(setUserDetails({}));
                  window.location.href = `${ssoEndpoint}/auth/logout?redirectUrl=${window.location.href.split("?")[0]}`;
                }
              })
              .catch((err) => console.error("[COOKIE SYNC][HEADER] Error fetching user details:", err));
          }
        } else {
          console.log("[COOKIE SYNC][HEADER] Refresh token found but access token missing. Proactively refreshing token...");
          refreshAccessToken(() => getUserDetails())
            .then((data) => {
              if (data && data.status !== 401 && !(data instanceof Error)) {
                dispatch(setIsLogin(true));
                dispatch(setUserDetails(data || {}));
                window.localStorage.setItem("user", JSON.stringify(data));
              }
            })
            .catch((err) => console.error("[COOKIE SYNC][HEADER] Auto-refresh failed during initial sync:", err));
        }
      }
      if (access_token && refresh_token) {
        console.log("[COOKIE SYNC][HEADER] New tokens found in URL, syncing them...");
        addTokensToLocalStorage(access_token, refresh_token);
        getUserDetails()
          .then((data) => {
            if (data?.status === 401) {
              console.log("[COOKIE SYNC][HEADER] Fresh user details returned 401. Clearing tokens and logging out.");
              // Remove an tokens from localStorage
              localStorage.removeItem("access_token");
              localStorage.removeItem("refresh_token");
              localStorage.removeItem("user");
              localStorage.removeItem("commentsToken");
              clearAuthCookies();

              googleLogout();
              // loggingout user if refresh token expires
              window.location.href = `${ssoEndpoint}/auth/logout?redirectUrl=${window.location.href.split("?")[0]}`;
            } else {
              addSignUpLoginToDataLayer(window.location.href, data);
              sessionStorage.setItem("skip_auth_tracking", "true");
              dispatch(setIsLogin(true));
              dispatch(setUserDetails(data || {}));
              window.localStorage.setItem("user", JSON.stringify(data));

              // Safely remove tokens from URL and perform a clean redirect to clear tab title and history cache
              searchParamsObj.delete("access_token");
              searchParamsObj.delete("refresh_token");
              const newSearch = searchParamsObj.toString();
              window.location.replace(window.location.pathname + (newSearch ? `?${newSearch}` : ""));
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (userLocalStorage && userLocalStorage !== "undefined" && userdetails?.userData === undefined) {
        if (stored_access_token && stored_refresh_token) {
          console.log("[COOKIE SYNC][HEADER] Tokens exist. Setting setGoogleOneTap(false)");
          setGoogleOneTap(false);
        }
        if (typeof userLocalStorage === "string" && userLocalStorage.trim() !== "") {
          try {
            const parsedUser = JSON.parse(userLocalStorage);
            dispatch(setUserDetails(parsedUser));
          } catch (e) {
            console.error("[COOKIE SYNC][HEADER] Failed to parse userLocalStorage:", e);
          }
        }
      } else {
        console.log("[COOKIE SYNC][HEADER] Checking tokens for Google One Tap. stored_access_token:", !!stored_access_token, "stored_refresh_token:", !!stored_refresh_token);
        if (stored_access_token && stored_refresh_token) {
          console.log("[COOKIE SYNC][HEADER] Tokens exist. Setting setGoogleOneTap(false)");
          setGoogleOneTap(false);
        } else {
          console.log("[COOKIE SYNC][HEADER] Tokens missing. Setting setGoogleOneTap(true)");
          setGoogleOneTap(true);
        }
      }
    } else {
      setGoogleOneTap(true);
    }
  }, []);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          getScroll();
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [
    adClosed,
    lastScrollY,
    makeSecondaryApiCalls,
    showPrimaryHeader,
    showSecondaryHeader,
    showAdBanner,
    showStickyNavbar,
    showDesktopSecondaryHeader
  ]);
  useEffect(() => {
    if (adClosed) {
      getScroll();
    }
  }, [adClosed]);
  useEffect(() => {
    makeSecondaryApiCalls &&
      dispatch(setMakeSecondaryApiCallsTriggered(makeSecondaryApiCalls, makeSecondaryApiCallsDelay, isMobile));
  }, [makeSecondaryApiCalls]);
  const isHardcodedHeader = useMemo(() => {
    let headerType = "";
    if (pageType === "section-page" || pageType === "sub-section-page") {
      const customHeader = pageData?.collection?.metadata?.["custom-header"];
      if (customHeader === "cok2025") {
        headerType = "cok2025";
      } else if (customHeader === "festivals") {
        headerType = "festivals";
      } else if (customHeader === "Canara-Robeco") {
        headerType = "Canara-Robeco";
      }
    }
    return headerType;
  }, [pageType, pageData]);
  useEffect(() => {
    if (typeof document !== "undefined" && typeof window !== "undefined") {
      // Skip padding for custom headers - they handle their own spacing
      if (isHardcodedHeader) {
        document.body.style.paddingTop = "0px";
        document.body.style.paddingBottom = "0px";
        return;
      }
      const isMobileView = window.innerWidth < 769;
      if (isMobileView) {
        // Always reserve space for bottom elements to prevent CLS
        // This space is reserved whether elements are visible or not
        let bottomPadding = 0;
        if (showStickyNavbar && showAdBanner) {
          bottomPadding = 120; // navbar + banner
        } else if (showStickyNavbar) {
          bottomPadding = 52; // navbar only
        } else if (showAdBanner) {
          bottomPadding = 68; // banner only
        } else {
          bottomPadding = 0; // nothing visible
        }
        document.body.style.paddingBottom = `${bottomPadding}px`;
        // Reserve space for top headers
        let topPadding = 0;
        if (showPrimaryHeader && showSecondaryHeader) {
          topPadding = 82;
        } else if (showSecondaryHeader) {
          topPadding = 33;
        } else {
          topPadding = 0;
        }
        document.body.style.paddingTop = `${topPadding}px`;
      } else {
        document.body.style.paddingBottom = "0px";
        let desktopTopPadding = 62;
        if (showDesktopSecondaryHeader) {
          desktopTopPadding += 45;
        }
        document.body.style.paddingTop = `${desktopTopPadding}px`;
      }
    }
    return () => {
      if (typeof document !== "undefined") {
        document.body.style.paddingBottom = "0px";
        document.body.style.paddingTop = "0px";
        document.body.style.transition = "";
      }
    };
  }, [
    showStickyNavbar,
    showPrimaryHeader,
    showSecondaryHeader,
    showDesktopSecondaryHeader,
    showAdBanner,
    isHardcodedHeader
  ]);
  const signinHandler = (customSource) => {
    const loginSource = typeof customSource === "string" ? customSource : "header_button";
    if (window) {
      console.log(`DataLayer SSO_Page_Open Event (${loginSource})`);
      window.dataLayer.push({
        event: "SSO_Page_Open"
      });
      sessionStorage.setItem("sso_login_initiated_source", loginSource);
      localStorage.removeItem("last_logged_in_uuid");
    }
    setTimeout(() => {
      window.location.assign(`${ssoEndpoint}/auth?redirectUrl=${encodeURIComponent(redirectURL)}`);
    }, 300);
  };
  return (
    <GoogleOAuthProvider clientId={GoogleClientId}>
      <NavigationSchema />
      <GlobalSubscriptionSyncer />
      {loadOneTap && <GoogleOneTapSignInUp />}
      <div className="header-hide-tab">
        <DesktopHeader
          signinHandler={signinHandler}
          isHardcodedHeader={isHardcodedHeader}
          showSecondaryHeader={showDesktopSecondaryHeader}
          onAccountHandler={openAccountModal}
          isSubscriber={isSubscriber || subscriptionActive}
          showRedirectSupportStrip={showRedirectSupportStrip || showPaymentProcessingBanner}
        />
      </div>
      <div className="header-hide-dektop">
        <MobileHeader
          signinHandler={signinHandler}
          isHardcodedHeader={isHardcodedHeader}
          showPrimaryHeader={showPrimaryHeader}
          showSecondaryHeader={showSecondaryHeader}
          onAccountHandler={openAccountModal}
          isSubscriber={isSubscriber || subscriptionActive}
          showRedirectSupportStrip={showRedirectSupportStrip || showPaymentProcessingBanner}
        />
      </div>
      {/* <EPaperBanner utmMedium="topbanner" pageType={pageType} isHardcodedHeader={isHardcodedHeader} /> */}
      {isHardcodedHeader !== "Canara-Robeco" && (
        <StickyBanner isVisible={showAdBanner} hasBottomNav={showStickyNavbar} />
      )}
      <StickyNavbar onMenuToggle={toggleHandler} menuItems={bottomNavBarMenus} isVisible={showStickyNavbar} />
      {/* <ElectionFloatingWidget /> */}
      <Snackbar />
      {showOnboardModal && <OnboardModal onClose={() => setShowOnboardModal(false)} />}
    </GoogleOAuthProvider>
  );
};


// Wrapper Header component that provides AccessType context
const Header = () => {
  const qt = useSelector((state) => get(state, ["qt"], {}));
  const userdetails = useSelector((state) => get(state, ["user", "user"], {}));
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));

  // Get AccessType configuration from Redux, similar to SubscriptionPage
  const ck = get(qt, ["config", "publisher-attributes", "subscription_setup"], {});
  const aKey = ck.accesstype_key || get(qt, ["config", "publisher-attributes", "accesstype_key"], "");

  // Only pass user data if logged in
  const email = userdetails?.userData?.emails?.[0] || userdetails?.email || "";
  const phone = userdetails?.userData?.phoneNumbers?.[0] || userdetails?.userData?.phone || userdetails?.phone || "";
  console.log("[Header] AccessType config:", { aKey, email, phone, isUserLogin });

  return (
    <AccessType
      accessTypeKey={aKey}
      accessTypeBkIntegrationId={ck.accesstype_subauth || ""}
      enableAccesstype={true}
      email={email}
      phone={phone}
    >
      {(props) => <HeaderInner {...props} />}
    </AccessType>
  );
};
export { Header };
